/**
 * @name: Boost Recommendation Swiper
 * @date: 2026-08-07
 * @description: Replace Boost Slick recommendation carousels with site Swiper (trackpad + progress)
 * @dependencies: swiper-bundle.min.js, boost-slick-progress.css
 * @strict-mode: true
 */

(function () {
    // Convert as soon as Boost mounts product cards — do not wait for Slick
    const SLIDER_SELECTOR = [
      '.boost-sd__recommendation .boost-sd__slider-container',
      '.boost-sd-layout .boost-sd__slider-container',
      '.boost-sd__slider .boost-sd__slider-container',
      '.boost-sd__slider-container',
    ].join(', ');
    const PROGRESS_CLASS = 'boost-slick-progress';
    const INIT_ATTR = 'data-boost-swiper-init';
    const WHEEL_SENSITIVITY = 18;
  
    /** @type {*|null} */
    let capturedJQuery = null;
  
    /**
     * @param {*} jq
     */
    function considerJQuery(jq) {
      if (!jq || !jq.fn) return;
      // Install trap even before slick.js loads so Boost cannot assign an unwrapped slick
      guardSlickFromReinit(jq);
      if (typeof jq.fn.slick === 'function') {
        capturedJQuery = jq;
      }
    }

    /**
     * Permanently intercept jQuery.fn.slick so Boost cannot overwrite our guard
     * (Boost often assigns slick.js AFTER we first wrap — that was wiping the hook
     * before "Recently viewed" initialized, so only "You may also like" was fast).
     * @param {*} jq
     */
    function guardSlickFromReinit(jq) {
      if (!jq || !jq.fn) return;

      const desc = Object.getOwnPropertyDescriptor(jq.fn, 'slick');
      const trapIntact = Boolean(jq.fn.__boostSlickTrap && desc && typeof desc.set === 'function');

      if (trapIntact) {
        // Ensure whatever is currently exposed is still our wrapped slick
        if (typeof jq.fn.slick === 'function' && !jq.fn.slick.__boostSwiperGuarded) {
          try {
            jq.fn.slick = jq.fn.slick;
          } catch (err) {
            // ignore
          }
        }
        return;
      }

      /**
       * @param {Function} original
       * @returns {Function}
       */
      function wrapSlick(original) {
        if (!original || original.__boostSwiperGuarded) return original;

        /**
         * @param {...*} args
         * @returns {*}
         */
        function guardedSlick(...args) {
          const action = args[0];
          const isInitCall =
            action === undefined ||
            action === null ||
            typeof action === 'object' ||
            action === 'init';

          if (isInitCall) {
            // Steal the carousel at the moment Boost would init Slick
            this.each(function eachBeforeSlick() {
              if (!(this instanceof HTMLElement)) return;
              if (this.getAttribute(INIT_ATTR) === 'true') return;
              if (!isRecommendationProductSlider(this)) return;
              if (!getSwiper()) return;
              initSwiperOnSlider(this);
            });

            const blocked = [];
            this.each(function eachSlider() {
              if (this instanceof HTMLElement && this.getAttribute(INIT_ATTR) === 'true') {
                blocked.push(this);
              }
            });

            if (blocked.length && blocked.length === this.length) {
              return this;
            }

            if (blocked.length) {
              const $allowed = this.filter(function filterAllowed() {
                return !(this instanceof HTMLElement && this.getAttribute(INIT_ATTR) === 'true');
              });
              if (!$allowed.length) return this;
              return original.apply($allowed, args);
            }
          }

          return original.apply(this, args);
        }

        guardedSlick.__boostSwiperGuarded = true;
        return guardedSlick;
      }

      const existing = typeof jq.fn.slick === 'function' ? jq.fn.slick : null;
      let currentSlick = existing ? wrapSlick(existing) : null;

      try {
        Object.defineProperty(jq.fn, 'slick', {
          configurable: true,
          enumerable: true,
          get() {
            return currentSlick;
          },
          set(value) {
            currentSlick = typeof value === 'function' ? wrapSlick(value) : value;
          },
        });
        jq.fn.__boostSlickTrap = true;
      } catch (err) {
        // Fallback if fn is sealed
        if (currentSlick) {
          jq.fn.slick = currentSlick;
        }
      }
    }
  
    considerJQuery(window.jQuery);
    considerJQuery(window.$);
  
    try {
      if (!capturedJQuery) {
        let currentJQ = window.jQuery;
        Object.defineProperty(window, 'jQuery', {
          configurable: true,
          enumerable: true,
          get() {
            return currentJQ;
          },
          set(value) {
            currentJQ = value;
            considerJQuery(value);
          },
        });
      }
    } catch (err) {
      // ignore
    }
  
    /**
     * @returns {typeof window.Swiper|null}
     */
    function getSwiper() {
      return typeof window.Swiper === 'function' ? window.Swiper : null;
    }
  
    /**
     * @param {HTMLElement} sliderEl
     * @returns {boolean}
     */
    function isRecommendationProductSlider(sliderEl) {
      if (sliderEl.closest('.boost-sd__slider--thumb-vertical')) return false;
      if (sliderEl.querySelector('.boost-sd__thumbs-container')) return false;
  
      return Boolean(
        sliderEl.querySelector(
          '.boost-sd__product-item, .boost-sd__suggestion-queries-item-product, .slick-slide',
        ),
      );
    }
  
    /**
     * @param {HTMLElement} sliderEl
     * @returns {HTMLElement}
     */
    function getSliderRoot(sliderEl) {
      return sliderEl.closest('.boost-sd__slider') || sliderEl.parentElement || sliderEl;
    }
  
    /**
     * Boost sometimes re-applies Slick after we convert → nested slick-list around Swiper.
     * @param {HTMLElement} sliderEl
     * @returns {boolean}
     */
    function isBrokenHybrid(sliderEl) {
      if (sliderEl.getAttribute(INIT_ATTR) !== 'true') return false;
      if (sliderEl.classList.contains('slick-initialized')) return true;
      return Boolean(
        [...sliderEl.children].find(
          (child) =>
            child.classList.contains('slick-list') ||
            child.classList.contains('slick-track'),
        ),
      );
    }

    /**
     * Strip outer Slick chrome classes/nodes from the recommendation track only.
     * @param {HTMLElement} sliderEl
     */
    function stripOuterSlickChrome(sliderEl) {
      [...sliderEl.children].forEach((child) => {
        if (
          child.classList.contains('slick-list') ||
          child.classList.contains('slick-dots') ||
          child.classList.contains('slick-arrow') ||
          child.classList.contains('slick-prev') ||
          child.classList.contains('slick-next')
        ) {
          child.remove();
        }
      });

      sliderEl.classList.remove(
        'slick-initialized',
        'slick-slider',
        'slick-dotted',
        'slick-vertical',
      );
      sliderEl.removeAttribute('style');
    }

    /**
     * Prefer Boost/jQuery unslick; fall back to manual DOM unwrap.
     * Only touches the outer recommendation track — never nested product-image carousels.
     * @param {HTMLElement} sliderEl
     * @returns {HTMLElement[]} original slide contents (detached)
     */
    function destroySlickAndExtractSlides(sliderEl) {
      considerJQuery(window.jQuery);
      considerJQuery(window.$);
      const jq = capturedJQuery;

      if (jq) {
        try {
          const $el = jq(sliderEl);
          if ($el.length && typeof $el.slick === 'function' && $el.hasClass('slick-initialized')) {
            $el.slick('unslick');
          }
        } catch (err) {
          // continue with DOM unwrap
        }
      }

      /**
       * Outer product slides we already built (repair path when Boost re-Slicks our Swiper).
       * @returns {HTMLElement[]}
       */
      function extractOurSwiperSlideContents() {
        const ourSlides = [...sliderEl.querySelectorAll('.boost-sd__swiper-slide')].filter(
          (slide) => !slide.closest('[data-product-image-swiper], .boost-sd__product-image'),
        );

        if (!ourSlides.length) return [];

        return ourSlides
          .map((slide) => {
            const inner = slide.children.length === 1 ? slide.firstElementChild : null;
            return inner instanceof HTMLElement ? inner : slide;
          })
          .filter(Boolean);
      }

      /**
       * Outer slick track only (not inside a product card / product image).
       * @returns {HTMLElement|null}
       */
      function getOuterTrack() {
        const lists = [...sliderEl.querySelectorAll('.slick-list')];
        const outerList = lists.find(
          (list) => !list.closest('.boost-sd__product-item, .boost-sd__product-image'),
        );
        if (!outerList) return null;
        return outerList.querySelector(':scope > .slick-track') || outerList.querySelector('.slick-track');
      }

      // Repair / hybrid: pull product cards out of our previous Swiper slides
      const repairedContents = extractOurSwiperSlideContents();
      if (repairedContents.length) {
        repairedContents.forEach((node) => {
          if (node.parentElement) node.parentElement.removeChild(node);
        });
        stripOuterSlickChrome(sliderEl);
        sliderEl.replaceChildren();
        return repairedContents;
      }

      const remainingTrack = getOuterTrack();
      if (remainingTrack) {
        const realSlides = [...remainingTrack.children].filter(
          (el) => el.classList.contains('slick-slide') && !el.classList.contains('slick-cloned'),
        );

        const contents = realSlides
          .map((slide) => {
            // Skip Swiper a11y notification nodes Boost/Slick may wrap
            if (slide.querySelector(':scope > .swiper-notification')) return null;
            // Slick usually wraps the original item in one child
            const inner = slide.children.length === 1 ? slide.firstElementChild : null;
            if (inner?.classList?.contains('swiper-wrapper')) {
              // Hybrid remnant: unwrap product cards from nested swiper-wrapper
              return [...inner.querySelectorAll(':scope > .boost-sd__swiper-slide')].map((s) => {
                const card = s.children.length === 1 ? s.firstElementChild : s;
                return card instanceof HTMLElement ? card : null;
              });
            }
            return inner || slide;
          })
          .flat()
          .filter(Boolean);

        contents.forEach((node) => {
          if (node.parentElement) node.parentElement.removeChild(node);
        });

        const outerList = remainingTrack.closest('.slick-list');
        if (outerList) outerList.remove();

        stripOuterSlickChrome(sliderEl);
        return contents;
      }

      stripOuterSlickChrome(sliderEl);

      // Pre-Slick Boost markup: product cards (or slide wrappers) as direct children
      const directProducts = [...sliderEl.children].filter((el) =>
        el.classList.contains('boost-sd__product-item') ||
        el.classList.contains('boost-sd__slide') ||
        el.querySelector(':scope > .boost-sd__product-item'),
      );

      if (directProducts.length) {
        return directProducts.map((el) => {
          if (el.classList.contains('boost-sd__product-item')) return el;
          const nested = el.querySelector(':scope > .boost-sd__product-item');
          return nested instanceof HTMLElement ? nested : el;
        });
      }

      return [...sliderEl.children].filter(
        (el) =>
          !el.classList.contains(PROGRESS_CLASS) &&
          !el.classList.contains('boost-sd__slider-button') &&
          !el.classList.contains('slick-dots') &&
          !el.classList.contains('swiper-notification'),
      );
    }
  
    /**
     * After we move product cards into a new Swiper, nested image carousels must be rebuilt.
     * @param {HTMLElement} scope
     */
    function reinitNestedProductImageSwipers(scope) {
      if (scope._boostNestedImageSwiperInitScheduled) return;
      scope._boostNestedImageSwiperInitScheduled = true;

      const imageSwipers = scope.querySelectorAll(
        '.boost-sd__product-image [data-product-image-swiper], .boost-sd__product-item [data-product-image-swiper], [data-product-image-swiper]',
      );
  
      for (const el of imageSwipers) {
        if (!(el instanceof HTMLElement)) continue;

        // Healthy nested swipers do not need teardown — destroying them retriggers width math on the outer carousel.
        if (el.swiper && el.dataset.initialized === 'true') continue;
  
        if (el.swiper && typeof el.swiper.destroy === 'function') {
          try {
            el.swiper.destroy(true, true);
          } catch (err) {
            // ignore destroy errors from stale instances
          }
        }
  
        delete el.dataset.initialized;
        el.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
      }
  
      const runInit = () => {
        if (typeof window.initProductImageSwipers === 'function') {
          window.initProductImageSwipers(scope);
          return;
        }
        // Fallback: init directly if global helper isn't on this template yet
        if (typeof window.Swiper !== 'function') return;
  
        for (const el of scope.querySelectorAll('[data-product-image-swiper]')) {
          if (!(el instanceof HTMLElement) || el.dataset.initialized === 'true') continue;
          if (!el.querySelector('.swiper-wrapper')) continue;
  
          el.dataset.initialized = 'true';
          const scopeEl =
            el.closest('.boost-sd__product-item, .boost-sd__product-image, .product-collection-showcase__card') ||
            el.parentElement;
          const prevBtn = scopeEl?.querySelector(
            '.product-collection-showcase__card-image-arrow--prev, .product-showcase-card__card-image-arrow--prev, [class*="__card-image-arrow--prev"]',
          );
          const nextBtn = scopeEl?.querySelector(
            '.product-collection-showcase__card-image-arrow--next, .product-showcase-card__card-image-arrow--next, [class*="__card-image-arrow--next"]',
          );
  
          new window.Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            nested: true,
            allowTouchMove: true,
            navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : undefined,
          });
        }
      };
  
      // Single pass after the outer carousel layout is stable — repeated inits were recalculating slide widths on mobile.
      window.requestAnimationFrame(runInit);
    }
  
    /**
     * Build Swiper markup inside the former Slick container.
     * @param {HTMLElement} sliderEl
     * @param {HTMLElement[]} slideContents
     */
    function buildSwiperMarkup(sliderEl, slideContents) {
      sliderEl.replaceChildren();
      sliderEl.classList.add('swiper', 'boost-sd__swiper');
      sliderEl.classList.remove('slick-initialized', 'slick-slider', 'slick-dotted');
  
      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
  
      for (const content of slideContents) {
        if (!(content instanceof HTMLElement)) continue;
  
        const slide = document.createElement('div');
        slide.className = 'swiper-slide boost-sd__swiper-slide';
        slide.appendChild(content);
        wrapper.appendChild(slide);
      }
  
      sliderEl.appendChild(wrapper);
    }
  
    /**
     * @param {HTMLElement} sliderEl
     * @returns {HTMLElement}
     */
    function getOrCreateProgress(sliderEl) {
      const root = getSliderRoot(sliderEl);
      const existing =
        root.querySelector(`:scope > .${PROGRESS_CLASS}`) ||
        (sliderEl.nextElementSibling?.classList.contains(PROGRESS_CLASS)
          ? sliderEl.nextElementSibling
          : null);
  
      if (existing instanceof HTMLElement) return existing;
  
      const progressEl = document.createElement('div');
      progressEl.className = PROGRESS_CLASS;
      progressEl.setAttribute('role', 'slider');
      progressEl.setAttribute('aria-label', 'Carousel position');
      progressEl.innerHTML = '<div class="boost-slick-progress__thumb" aria-hidden="true"></div>';
      progressEl.style.pointerEvents = 'auto';
      sliderEl.insertAdjacentElement('afterend', progressEl);
  
      return progressEl;
    }
  
    /** Mobile-first — let Swiper breakpoints own width math (no manual resize overrides). */
    const RECOMMENDATION_SWIPER_BREAKPOINTS = {
      750: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    };
  
    /**
     * @param {HTMLElement} progressEl
     * @param {Object} swiper
     * @param {number} [progressOverride]
     */
    function updateProgressBar(progressEl, swiper, progressOverride) {
      const thumb = progressEl.querySelector('.boost-slick-progress__thumb');
      if (!thumb || !swiper) return;
  
      const slideCount = swiper.slides?.length || 0;
      if (slideCount <= 1) {
        progressEl.hidden = true;
        return;
      }
  
      const spvRaw = swiper.params?.slidesPerView;
      const spv = typeof spvRaw === 'number' ? spvRaw : Number(spvRaw) || 1;
      if (slideCount <= Math.ceil(spv)) {
        progressEl.hidden = true;
        return;
      }
  
      progressEl.hidden = false;
      progressEl.style.pointerEvents = 'auto';
  
      const thumbPct = Math.min(100, Math.max(8, (spv / slideCount) * 100));
      const travelPct = 100 - thumbPct;
      const progress =
        typeof progressOverride === 'number' && !Number.isNaN(progressOverride)
          ? Math.min(1, Math.max(0, progressOverride))
          : Math.min(1, Math.max(0, swiper.progress));
  
      thumb.style.width = `${thumbPct}%`;
      thumb.style.left = `${progress * travelPct}%`;
    }
  
    /**
     * Draggable + clickable progress scrubber (matches product-collection-showcase).
     * @param {HTMLElement} progressEl
     * @param {Object} swiper
     */
    function setupProgressBarDrag(progressEl, swiper) {
      if (progressEl.getAttribute('data-boost-progress-drag') === 'true') {
        progressEl._boostSwiper = swiper;
        return;
      }
  
      progressEl.setAttribute('data-boost-progress-drag', 'true');
      progressEl.setAttribute('role', 'slider');
      progressEl.setAttribute('aria-label', 'Carousel position');
      progressEl.setAttribute('aria-valuemin', '0');
      progressEl.setAttribute('aria-valuemax', '100');
      progressEl.tabIndex = 0;
      progressEl.style.pointerEvents = 'auto';
      progressEl._boostSwiper = swiper;
  
      let activePointerId = null;
      let dragRafId = null;
      let lastClientX = null;
      let dragRect = null;
      let didMove = false;
  
      /**
       * @param {number} clientX
       * @returns {number}
       */
      function getProgressFromX(clientX) {
        const rect = dragRect || progressEl.getBoundingClientRect();
        if (!rect.width) return 0;
        return Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      }
  
      /**
       * @param {number} progress
       */
      function setAriaValue(progress) {
        progressEl.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
      }
  
      /**
       * Move carousel + thumb to a 0–1 progress position.
       * @param {number} clientX
       * @param {{ animate?: boolean }} [options]
       */
      function goToClientX(clientX, options = {}) {
        const instance = progressEl._boostSwiper;
        if (!instance) return;
  
        const animate = Boolean(options.animate);
        const progress = getProgressFromX(clientX);
  
        updateProgressBar(progressEl, instance, progress);
        setAriaValue(progress);
  
        if (typeof instance.setProgress === 'function') {
          instance.setProgress(progress, animate ? 300 : 0);
          return;
        }
  
        // Fallback: snap by snapGrid (accounts for slidesPerView)
        const snaps = instance.snapGrid || [];
        const maxSnap = Math.max(snaps.length - 1, 0);
        const snapIndex = Math.round(progress * maxSnap);
        if (typeof instance.slideTo === 'function') {
          instance.slideTo(snapIndex, animate ? 300 : 0);
        }
      }
  
      function onMove(e) {
        if (e.pointerType === 'touch') e.preventDefault();
        lastClientX = e.clientX;
        didMove = true;
  
        if (dragRafId != null) return;
        dragRafId = requestAnimationFrame(() => {
          dragRafId = null;
          if (lastClientX == null) return;
          goToClientX(lastClientX, { animate: false });
        });
      }
  
      function endDrag(e) {
        if (activePointerId !== null && e.pointerId !== activePointerId) return;
  
        const finalX = lastClientX != null ? lastClientX : e.clientX;
        activePointerId = null;
  
        if (dragRafId != null) {
          cancelAnimationFrame(dragRafId);
          dragRafId = null;
        }
  
        if (finalX != null) {
          // Click = animate to position; drag already followed live — settle with a short ease
          goToClientX(finalX, { animate: !didMove });
        }
  
        lastClientX = null;
        didMove = false;
        dragRect = null;
        progressEl.classList.remove('is-dragging');
  
        try {
          progressEl.releasePointerCapture(e.pointerId);
        } catch (err) {
          // already released
        }
  
        progressEl.removeEventListener('pointermove', onMove);
        progressEl.removeEventListener('pointerup', endDrag);
        progressEl.removeEventListener('pointercancel', endDrag);
      }
  
      progressEl.addEventListener(
        'pointerdown',
        (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.cancelable) e.preventDefault();
  
          activePointerId = e.pointerId;
          dragRect = progressEl.getBoundingClientRect();
          lastClientX = e.clientX;
          didMove = false;
          progressEl.classList.add('is-dragging');
  
          // Immediate jump on click / drag start (clickable)
          goToClientX(e.clientX, { animate: false });
  
          progressEl.setPointerCapture(e.pointerId);
          progressEl.addEventListener('pointermove', onMove, { passive: false });
          progressEl.addEventListener('pointerup', endDrag);
          progressEl.addEventListener('pointercancel', endDrag);
        },
        { passive: false },
      );
  
      // Keyboard support for accessibility
      progressEl.addEventListener('keydown', (e) => {
        const instance = progressEl._boostSwiper;
        if (!instance) return;
  
        const step = 0.08;
        let next = instance.progress;
  
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
          e.preventDefault();
          next = Math.min(1, next + step);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
          e.preventDefault();
          next = Math.max(0, next - step);
        } else if (e.key === 'Home') {
          e.preventDefault();
          next = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          next = 1;
        } else {
          return;
        }
  
        updateProgressBar(progressEl, instance, next);
        setAriaValue(next);
        if (typeof instance.setProgress === 'function') {
          instance.setProgress(next, 300);
        }
      });
    }
  
    /**
     * @param {HTMLElement} sliderEl
     * @param {Object} swiper
     * @param {HTMLElement} progressEl
     */
    function setupTrackpad(sliderEl, swiper, progressEl) {
      progressEl._boostSwiper = swiper;
      sliderEl._boostSwiper = swiper;

      if (sliderEl.getAttribute('data-boost-progress-wheel') === 'true') return;
      sliderEl.setAttribute('data-boost-progress-wheel', 'true');

      let accumulatedWheelDelta = 0;
      let wheelRafId = null;
      let isWheelScrolling = false;

      sliderEl.addEventListener(
        'wheel',
        (e) => {
          const instance = sliderEl._boostSwiper;
          if (!instance || progressEl.classList.contains('is-dragging')) return;

          const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
          if (!isHorizontal) return;

          accumulatedWheelDelta += -e.deltaX * WHEEL_SENSITIVITY;
          if (Math.abs(accumulatedWheelDelta) < 0.5) return;

          e.preventDefault();
          isWheelScrolling = true;

          if (wheelRafId != null) return;

          wheelRafId = requestAnimationFrame(() => {
            wheelRafId = null;

            const live = sliderEl._boostSwiper;
            if (!live || Math.abs(accumulatedWheelDelta) < 0.5) {
              isWheelScrolling = false;
              return;
            }

            const swiperMin = live.minTranslate();
            const swiperMax = live.maxTranslate();
            const minT = Math.min(swiperMin, swiperMax);
            const maxT = Math.max(swiperMin, swiperMax);
            const t =
              typeof live.getTranslate === 'function' ? live.getTranslate() : live.translate;
            const delta = accumulatedWheelDelta;
            accumulatedWheelDelta = 0;

            let newT = t + delta;
            newT = Math.max(minT, Math.min(maxT, newT));
            const progress = maxT !== minT ? (newT - maxT) / (minT - maxT) : 0;

            if (typeof live.setTransition === 'function') live.setTransition(0);
            live.setTranslate(newT);
            if (typeof live.setTransition === 'function') live.setTransition(300);

            updateProgressBar(progressEl, live, progress);
            isWheelScrolling = false;
          });
        },
        { passive: false },
      );

      // Expose for progress updates that should ignore mid-wheel noise
      progressEl._boostIsWheelScrolling = () => isWheelScrolling;
    }

    /** @type {WeakMap<HTMLElement, number>} */
    const lastRepairAt = new WeakMap();

    /**
     * Destroy a previous conversion so we can rebuild after Boost re-Slicks.
     * @param {HTMLElement} sliderEl
     */
    function teardownConvertedSlider(sliderEl) {
      const existing = sliderEl._boostSwiper || sliderEl.swiper;
      if (existing && typeof existing.destroy === 'function') {
        try {
          existing.destroy(true, true);
        } catch (err) {
          // ignore stale instance errors
        }
      }

      sliderEl._boostSwiper = null;
      sliderEl.removeAttribute(INIT_ATTR);
      sliderEl.removeAttribute('data-boost-progress-wheel');
      sliderEl.classList.remove(
        'swiper',
        'boost-sd__swiper',
        'swiper-initialized',
        'swiper-horizontal',
        'swiper-backface-hidden',
        'swiper-watch-progress',
      );
    }

    /**
     * @param {HTMLElement} sliderEl
     */
    function repairBrokenHybrid(sliderEl) {
      const now = Date.now();
      const last = lastRepairAt.get(sliderEl) || 0;
      // Cooldown prevents repair loops that visibly bounce the carousel on mobile.
      if (now - last < 400) return;
      lastRepairAt.set(sliderEl, now);

      teardownConvertedSlider(sliderEl);
      initSwiperOnSlider(sliderEl);
    }

    /**
     * Watch a converted slider so Boost re-Slick is repaired immediately (no multi-second wait).
     * @param {HTMLElement} sliderEl
     */
    function watchForBoostReslick(sliderEl) {
      if (sliderEl._boostReslickObserver) return;

      const observer = new MutationObserver(() => {
        if (isBrokenHybrid(sliderEl)) {
          repairBrokenHybrid(sliderEl);
        }
      });

      observer.observe(sliderEl, { childList: true, attributes: true, attributeFilter: ['class'] });
      sliderEl._boostReslickObserver = observer;
    }

    /**
     * @param {HTMLElement} sliderEl
     */
    function initSwiperOnSlider(sliderEl) {
      if (sliderEl.getAttribute(INIT_ATTR) === 'true') {
        if (isBrokenHybrid(sliderEl)) {
          repairBrokenHybrid(sliderEl);
        }
        return;
      }
      if (!isRecommendationProductSlider(sliderEl)) return;

      const SwiperCtor = getSwiper();
      if (!SwiperCtor) return;

      sliderEl.setAttribute(INIT_ATTR, 'true');

      const slideContents = destroySlickAndExtractSlides(sliderEl);
      if (!slideContents.length) {
        sliderEl.removeAttribute(INIT_ATTR);
        return;
      }

      buildSwiperMarkup(sliderEl, slideContents);

      const progressEl = getOrCreateProgress(sliderEl);
      const thumb = progressEl.querySelector('.boost-slick-progress__thumb');
      if (!thumb) return;

      // Hide Boost native controls — Swiper + progress replace them
      const root = getSliderRoot(sliderEl);
      root.querySelectorAll('.boost-sd__slider-button, .boost-sd__prev-button, .boost-sd__next-button').forEach((btn) => {
        btn.setAttribute('hidden', 'true');
      });

      let resizeDebounceTimer = null;

      const swiper = new SwiperCtor(sliderEl, {
        slidesPerView: 1.6,
        spaceBetween: 0,
        slidesPerGroup: 1,
        freeMode: false,
        grabCursor: true,
        resistance: true,
        resistanceRatio: 0.85,
        speed: 300,
        loop: true,
        allowTouchMove: true,
        watchOverflow: true,
        breakpoints: RECOMMENDATION_SWIPER_BREAKPOINTS,
        on: {
          init(instance) {
            // Only strip leftover Slick classes — never remove child nodes here
            // (Boost may wrap our Swiper in .slick-list; deleting it would wipe slides)
            sliderEl.classList.remove(
              'slick-initialized',
              'slick-slider',
              'slick-dotted',
              'slick-vertical',
            );

            if (isBrokenHybrid(sliderEl)) {
              window.requestAnimationFrame(() => repairBrokenHybrid(sliderEl));
              return;
            }

            updateProgressBar(progressEl, instance);
            setupProgressBarDrag(progressEl, instance);
            setupTrackpad(sliderEl, instance, progressEl);
            reinitNestedProductImageSwipers(sliderEl);
          },
          slideChange(instance) {
            if (progressEl.classList.contains('is-dragging')) return;
            if (progressEl._boostIsWheelScrolling?.()) return;
            updateProgressBar(progressEl, instance);
          },
          progress(instance) {
            if (progressEl.classList.contains('is-dragging')) return;
            if (progressEl._boostIsWheelScrolling?.()) return;
            updateProgressBar(progressEl, instance);
          },
          resize(instance) {
            if (resizeDebounceTimer) clearTimeout(resizeDebounceTimer);
            resizeDebounceTimer = setTimeout(() => {
              // Swiper breakpoints already recalculate slide widths — only sync the progress thumb.
              updateProgressBar(progressEl, instance);
            }, 150);
          },
        },
      });

      sliderEl._boostSwiper = swiper;
      progressEl._boostSwiper = swiper;
      watchForBoostReslick(sliderEl);

      // Quick follow-ups in case Boost mutates after our observer attaches
      for (const ms of [0, 50, 200, 600]) {
        window.setTimeout(() => {
          if (isBrokenHybrid(sliderEl)) {
            repairBrokenHybrid(sliderEl);
          } else {
            sliderEl.classList.remove(
              'slick-initialized',
              'slick-slider',
              'slick-dotted',
              'slick-vertical',
            );
          }
        }, ms);
      }
    }

    function scan() {
      // Keep jQuery/slick trap alive — Boost may load slick.js after our first pass
      considerJQuery(window.jQuery);
      considerJQuery(window.$);

      if (!getSwiper()) return;

      // Repair carousels Boost re-wrapped with Slick after our conversion
      const converted = document.querySelectorAll(`[${INIT_ATTR}="true"]`);
      for (const slider of converted) {
        if (!(slider instanceof HTMLElement)) continue;
        if (isBrokenHybrid(slider)) {
          repairBrokenHybrid(slider);
        }
      }

      const sliders = document.querySelectorAll(SLIDER_SELECTOR);

      for (const slider of sliders) {
        if (!(slider instanceof HTMLElement)) continue;
        if (slider.getAttribute(INIT_ATTR) === 'true') continue;
        if (!isRecommendationProductSlider(slider)) continue;
        // Need at least one product card before converting (skip empty placeholders)
        if (
          !slider.querySelector(
            '.boost-sd__product-item, .boost-sd__suggestion-queries-item-product, .slick-slide',
          )
        ) {
          continue;
        }
        initSwiperOnSlider(slider);
      }
    }

    /**
     * Convert as soon as Boost mounts cards — especially important for later widgets
     * like "Recently viewed" which init Slick after "You may also like".
     */
    function start() {
      let tries = 0;
      const maxTries = 150;
      /** @type {ReturnType<typeof setTimeout>|null} */
      let scanDebounceTimer = null;

      const scheduleScan = (immediate = false) => {
        if (immediate) {
          if (scanDebounceTimer) {
            clearTimeout(scanDebounceTimer);
            scanDebounceTimer = null;
          }
          scan();
          return;
        }
        if (scanDebounceTimer) return;
        scanDebounceTimer = setTimeout(() => {
          scanDebounceTimer = null;
          scan();
        }, 0);
      };

      const tick = () => {
        scan();
        tries += 1;
        if (tries < maxTries) {
          const delay = tries < 80 ? 40 : 150;
          window.setTimeout(tick, delay);
        }
      };

      tick();

      const observer = new MutationObserver((mutations) => {
        let urgent = false;
        for (const mutation of mutations) {
          if (mutation.type !== 'childList') continue;
          for (const node of mutation.addedNodes) {
            if (!(node instanceof HTMLElement)) continue;
            if (
              node.classList?.contains('boost-sd__product-item') ||
              node.classList?.contains('boost-sd__slider-container') ||
              node.classList?.contains('boost-sd__recommendation') ||
              node.classList?.contains('slick-initialized') ||
              node.querySelector?.(
                '.boost-sd__product-item, .boost-sd__slider-container, .slick-initialized',
              )
            ) {
              urgent = true;
              break;
            }
          }
          if (urgent) break;
        }
        scheduleScan(urgent);
      });

      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          observer.observe(document.body, { childList: true, subtree: true });
          scan();
        });
      }
    }

    /**
     * Boost Recommendation module (official TAEApp API).
     * @returns {{ initBlocks?: Function, blocks?: Record<string, unknown> }|null}
     */
    function getRecommendationModule() {
      const tae = window.boostWidgetIntegration?.TAEApp;
      if (!tae || typeof tae.getModuleByName !== 'function') return null;

      try {
        return tae.getModuleByName('Recommendation') || null;
      } catch (err) {
        return null;
      }
    }

    /**
     * Sync Boost + Shopify product context after an SPA colorway swap.
     * boostSDData.product and dataObjects.product share the same reference.
     * @param {object|null|undefined} product
     */
    function syncBoostProductContext(product) {
      if (!product || product.id == null) return;

      if (window.boostSDData) {
        window.boostSDData.product = product;
      }

      const dataObjects = window.boostWidgetIntegration?.dataObjects;
      if (dataObjects && dataObjects.product !== product) {
        dataObjects.product = product;
      }

      if (window.meta?.product) {
        window.meta.product.id = product.id;
        window.meta.product.handle = product.handle;
        window.meta.product.type = product.type;
        window.meta.product.vendor = product.vendor;
      }

      if (window.ShopifyAnalytics?.meta?.product) {
        window.ShopifyAnalytics.meta.product.id = product.id;
        window.ShopifyAnalytics.meta.product.handle = product.handle;
        window.ShopifyAnalytics.meta.product.type = product.type;
        window.ShopifyAnalytics.meta.product.vendor = product.vendor;
      }
    }

    /**
     * Unregister Boost recommendation blocks so registerBlock can run again.
     * TAEApp.registerBlock no-ops when the id already exists.
     */
    function unregisterRecommendationBlocks() {
      const bwi = window.boostWidgetIntegration;
      const tae = bwi?.TAEApp;
      const rec = getRecommendationModule();
      if (!bwi?.blocks) return;

      const widgetIds = Object.keys(bwi.blocks).filter((id) => id.startsWith('boost-sd-widget-'));

      for (const id of widgetIds) {
        if (tae?.blocks) delete tae.blocks[id];
        delete bwi.blocks[id];
        if (rec?.blocks) delete rec.blocks[id];
      }
    }

    /**
     * Tear down our Swiper wrappers before Boost replaces widget HTML.
     */
    function teardownAllBoostSwipers() {
      const converted = document.querySelectorAll(`[${INIT_ATTR}="true"]`);

      for (const slider of converted) {
        if (!(slider instanceof HTMLElement)) continue;

        if (slider._boostReslickObserver) {
          try {
            slider._boostReslickObserver.disconnect();
          } catch (err) {
            // ignore
          }
          slider._boostReslickObserver = null;
        }

        teardownConvertedSlider(slider);
      }

      document.querySelectorAll(`.${PROGRESS_CLASS}`).forEach((el) => el.remove());
    }

    /**
     * Re-render Boost recommendation widgets (You may also like + Recently viewed)
     * after PDP colorway swap using Boost's Recommendation.initBlocks().
     * @param {object|null|undefined} product
     */
    function refreshBoostRecommendationWidgets(product) {
      syncBoostProductContext(product);
      teardownAllBoostSwipers();
      unregisterRecommendationBlocks();

      const rec = getRecommendationModule();
      if (rec && typeof rec.initBlocks === 'function') {
        try {
          rec.initBlocks();
          return;
        } catch (err) {
          // fall through to DOM fallback
        }
      }

      // Fallback if Recommendation module is not ready yet
      document.querySelectorAll('[id^="boost-sd-widget-"]').forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        el.innerHTML =
          '<!-- TEMPLATE RECOMMENDATION PLACEHOLDER--><div class="boost-sd__rc-pl"></div>';
      });

      window.setTimeout(() => {
        const retry = getRecommendationModule();
        if (retry && typeof retry.initBlocks === 'function') {
          unregisterRecommendationBlocks();
          try {
            retry.initBlocks();
          } catch (err) {
            // ignore
          }
        }
      }, 300);
    }

    document.addEventListener('pdp:swapped', (event) => {
      const product =
        event?.detail?.product ||
        window._theme?.productJson ||
        window.boostSDData?.product ||
        null;

      refreshBoostRecommendationWidgets(product);
      // Re-scan soon so Swiper conversion runs on the freshly rendered Boost carousels
      window.setTimeout(() => scan(), 100);
      window.setTimeout(() => scan(), 600);
      window.setTimeout(() => scan(), 1500);
    });

    start();
  })();
  
